import { createContext, useContext } from "react";
import { GeneralMapStore } from "./GeneralMapStore";

const GeneralMapStoreContext = createContext<GeneralMapStore | null>(null);

export const useGeneralMapStore = (): GeneralMapStore => {
	const generalMapStore = useContext(GeneralMapStoreContext);
	if (!generalMapStore) throw new Error("useGeneralMapStore must be used within <GeneralMapStoreProvider>");
	return generalMapStore;
};

export const GeneralMapStoreProvider = GeneralMapStoreContext.Provider;
